const state = {
    step: 'square-footage', //square-footage, shingle-layers, complexity, pitch-angle, material, labor, quote:
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
const mutations = {
  setStep(state, step) {
    state.step = step
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}